import { EServiceType } from '../../../../redux/reducers';

const SERVICE_TYPES: { [key: string]: EServiceType } = {
  Top3: EServiceType.top3,
  PremiumObject: EServiceType.premium,
  Highlight: EServiceType.highlight,
  DebitObject: EServiceType.paid,
  FreeObject: EServiceType.free,
};

export function mapServiceTypes(serviceTypes: string[]): EServiceType[] {
  return serviceTypes.map(serviceType => SERVICE_TYPES[serviceType]).filter(Boolean);
}
